import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const meetingRoomService = {
    getAll,
};

const MODULE = {
    MEETING_ROOM: 'portal/meeting-rooms',
};

const API_URL = API.BASE_URL_APP + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.MEETING_ROOM}`, request);
}